import {Stack} from '../../../layout/stack/stack';
import {SelectPickerGeneric} from '../../../select-picker-generic/select-picker-generic';
import {Body} from '../../../typography/body';

import {OCCURRENCE_OPTIONS, WEEKDAY_OPTIONS} from './consts';
import type {
    RecurrenceDueDateFormSetters,
    RecurrenceDueDateFormState,
} from './recurrence-due-date-mode-form-types';

interface Props {
    values: RecurrenceDueDateFormState;
    setters: RecurrenceDueDateFormSetters;
    isDisabled: boolean;
}

export function RecurrenceMonthlyOnRow(props: Props) {
    return (
        <Stack spacing={8} isHorizontal={true} alignItems='center'>
            <Body size='small' color={props.isDisabled ? 'light' : 'medium'}>
                on the
            </Body>
            <div style={{width: 90}}>
                <SelectPickerGeneric
                    options={OCCURRENCE_OPTIONS}
                    value={OCCURRENCE_OPTIONS.find(
                        (option) => option.value === props.values.occurrence
                    )}
                    // @ts-expect-error
                    onChange={(value) => {
                        props.setters.setOccurrence(value.value);
                    }}
                    isDisabled={props.isDisabled}
                    menuPlacement='auto'
                    menuPortalTarget={document.body}
                />
            </div>
            <div style={{width: 115}}>
                <SelectPickerGeneric
                    options={WEEKDAY_OPTIONS}
                    value={WEEKDAY_OPTIONS.find((option) => option.value === props.values.weekday)}
                    // @ts-expect-error
                    onChange={(value) => {
                        props.setters.setWeekday(value.value);
                    }}
                    isDisabled={props.isDisabled}
                    menuPlacement='auto'
                    menuPortalTarget={document.body}
                />
            </div>
        </Stack>
    );
}
